import {
  Inquiry,
  InquiryFetchArgs,
  getInquiries,
} from '../../assets/ts/data/inquiry/inquiry'
import { getInquiryOptions } from '../../assets/ts/data/inquiry/inquiry-options'
import useServerData from '../use-server-data'

function useInquiries(fetchArgs: InquiryFetchArgs) {
  const {
    data: inquiries,
    error: inquiriesError,
    fetchData: fetchInquiries,
    isLoading: inquiriesAreLoading,
  } = useServerData<Inquiry, InquiryFetchArgs>(getInquiries, fetchArgs)
  const options = getInquiryOptions(inquiries)
  return {
    fetchInquiries,
    getInquiryOptions,
    inquiries,
    inquiriesAreLoading,
    inquiriesError,
    options,
    refetch: fetchInquiries, // Add refetch to the return object
  }
}

export default useInquiries
